// extracted by mini-css-extract-plugin
export default {"primary":"\"RO Sans\", Calibri, sans-serif","secondary":"\"RO Serif\", Arial, sans-serif"};